import { render, staticRenderFns } from "./policy-table.vue?vue&type=template&id=5c80ec44&scoped=true&"
import script from "./policy-table.vue?vue&type=script&lang=js&"
export * from "./policy-table.vue?vue&type=script&lang=js&"
import style0 from "./policy-table.vue?vue&type=style&index=0&id=5c80ec44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c80ec44",
  null
  
)

export default component.exports